import {createContext} from 'react';
import {DEFAULT_START_STOP_VALUE} from 'src/internal/constants';

export default createContext<{
  start: (reason?: string | undefined) => void;
  stop: (reason?: string | undefined) => void;
}>(DEFAULT_START_STOP_VALUE);
